<template>
  <v-container id="Pagos-forms" fluid tag="section">
    <base-material-card color="#ac8a2e" icon="mdi-text-box-multiple" inline class="px-5 py-3" title="Recibos">
      <template v-slot:after-title>
        <v-btn color="#ac8a2e" dark icon @click="goToNewCorboForm('new', 0)">
          <v-icon large color="#ac8a2e">
            mdi-text-box-plus
          </v-icon>
        </v-btn>
      </template>
      <v-row align="end" justify="end">
        <v-col cols="5">
          <v-text-field v-model="buscar" append-icon="mdi-magnify" class="ml-auto" color="gold" label="Buscar" hide-details single-line style="max-width: 250px;" />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />
      <v-data-table
        :page="recibos.page"
        :page-count="recibos.last_page"
        :headers="headers"
        :items="recibos.data"
        :search.sync="buscar"
        :server-items-length="recibos.total"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: itemsPerPage
        }"
        disable-sort
        @update:options="getData($event)"
      >
        <template #item="{ item }">
          <tr :class="item.cancelado_sn === 0 ? '' : 'style-2'">
            <td class="text-start">
              {{ item.fecha }}
            </td>
            <td class="text-start">
              {{ generarNumero(item) }}
            </td>
            <td class="text-start">
              {{ item.fullName }}
            </td>
            <td class="text-start">
              {{ item.nombreClub }}
            </td>
            <td class="text-start">
              {{ item.nombreCt }}
            </td>
            <td class="text-start">
              {{ montoMoneda(item) }}
            </td>
            <td class="text-end">
              <v-tooltip v-if="tiempoParaCancelar(item)" content-class="top" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="confirmarAnular(item.id)">
                    mdi-cancel
                  </v-icon>
                </template>
                <span>Anular recibo</span>
              </v-tooltip>
              <v-tooltip content-class="top" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="gotoEdit(item.id)">
                    mdi-paperclip
                  </v-icon>
                </template>
                <span>Adjuntar documentación</span>
              </v-tooltip>
              <v-tooltip content-class="top" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="generarPdf2(item)">
                    mdi-file-pdf-box
                  </v-icon>
                </template>
                <span>Pdf</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import dayjs from 'dayjs'
  import confirm from '../../components/confirm'
  import GeneradorPdfRecibojs from '../../mixins/generadorPdfRecibo'

  export default {
    components: {
      confirm,
    },
    mixins: [GeneradorPdfRecibojs],
    data () {
      return {
        loading: true,
        op: {},
        itemsPerPage: [5, 10, 15],
        mesesCancelParemetrizado: '',
        buscar: '',
        typingTimer: {},
        totalItems: 0,
        headers: [
          { text: 'Fecha', align: 'start', sortable: true },
          { text: 'Número', align: 'start' },
          { text: 'Jugador' },
          { text: 'Club' },
          { text: 'Otros' },
          { text: 'Monto' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        recibos: [],
        reciboAMostrar: null,
        monedas: [],
      }
    },
    computed: {
    },
    watch: {
      buscar () {
        clearTimeout(this.typingTimer)
        this.typingTimer = setTimeout(() => this.readDataFromAPI(1, this.op.itemsPerPage), 1000)
      },
    },
    created () {
      this.getMoneda()
      this.getFechaParametrizada()
    },
    methods: {
      getMoneda () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/moneda' }).then(response => { this.monedas = response })
      },
      getData (data) {
        this.op = data
        this.readDataFromAPI(data.page, data.itemsPerPage)
      },
      readDataFromAPI: async function (page = 1, itemsPerPage = 10) {
        this.$store.dispatch('axiosMod/getData', { url: '/api/recibo_paginate_s' + '?page=' + page + '&itemsPerPage=' + itemsPerPage + '&filtro=' + this.buscar }).then(response => {
          this.recibos = response
          this.loading = false
        })
      },
      itemRowBackground: function (item) {
        return 'style-2'
      },
      generarNumero (item) {
        return (('00000000' + item.id).slice(-8))
      },
      montoMoneda (item) {
        return (this.simboloMoneda(item.moneda_id) + ' ' + item.monto)
      },
      simboloMoneda (monedaId) {
        return (this.monedas.length !== 0) ? this.monedas.find(e => e.id === monedaId).simbolo : '$'
      },
      goToNewCorboForm (modeVal, idRecibo) {
        this.$router.push({ name: 'Cobros', params: { id: idRecibo, mode: modeVal } })
      },
      confirmarAnular (reciboId) {
        this.$refs.confirm.open('Alerta', 'Está seguro de anular el recibo ?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.anularRecibo(reciboId)
          }
        })
      },
      anularRecibo: async function (reciboId) {
        this.$store.commit('loaderOn', 1)
        await this.$http({
          method: 'put',
          url: '/api/cancelarRecibo/' + reciboId,
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Recibo anulado'] })
          this.$store.commit('loaderOff')
          this.readDataFromAPI()
        }).catch(error => {
          if (error.response.data) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
          this.$store.commit('loaderOff')
        })
      },

      tiempoParaCancelar (recibo) {
        const today = dayjs()
        const diferencia = today.diff(recibo.fecha, 'month')
        return (diferencia <= parseInt(this.mesesCancelParemetrizado.valor)) && recibo.cancelado_sn !== 1
      },

      getFechaParametrizada () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/parametro/meses_recibo_cancela' }).then(response => { this.mesesCancelParemetrizado = response })
      },
      gotoEdit (idRecibo) {
        this.$router.push({ name: 'Adjuntar documentación', params: { id: idRecibo, mode: 'edit' } })
      },

      generarPdf2 (item) {
        // this.reciboAMostrar = item
        this.generarPdfRecibo(item.id)
      },
    },
  }
</script>

<style>
  .style-2 {
  background-color:rgb(255, 105, 97)
}
</style>
